import { createRouter, createWebHistory } from 'vue-router'
import LandingView from '@/views/LandingView.vue'
import JudgeView from '@/views/JudgeView.vue'
import ProductEditView from '@/views/ProductEditView.vue'
import UserManagementView from '@/views/UserManagementView.vue'
import { useAuthStore } from '@/stores/auth'

/**
 * ルーティング構成:
 *   /             : ログイン直後の選択画面(セルモン商品審査 / セルモン商品編集)
 *   /judge        : セルモン商品審査(旧: "/") - 審査Webのメイン画面
 *   /product-edit : セルモン商品編集 - 商品情報編集ツール(旧ProductOverwriter.exe)
 *                   単独起動が主だが、審査Webの「商品情報編集」リンクから
 *                   ?asin=XXXX&region=jp 付きで開くこともできる。
 *
 * 認証ゲート自体はApp.vue側(Cognito未ログイン時は自動リダイレクト)で行っており、
 * ここでは未認証時のガードは行わない(App.vueがrouter-view自体を認証済みの場合のみ
 * 描画する構成のため)。
 *
 * meta.title: ブラウザタブのタイトル。index.htmlは審査Web・商品編集Webで
 * 共有の1つしか無いため、ルート遷移のたびに動的にdocument.titleを書き換える。
 *
 * meta.favicon: ブラウザタブのfavicon。ランディングページのタイルアイコンと
 * 同じデザイン(審査=紫のチェックマーク、編集=青緑の鉛筆)を、画面ごとに
 * 切り替えて表示する(index.htmlのlink要素も同様にルート遷移のたびに書き換える)。
 */
const DEFAULT_FAVICON = '/favicon.svg'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: LandingView,
      meta: { title: 'セルモン審査', favicon: DEFAULT_FAVICON },
    },
    {
      path: '/judge',
      name: 'judge',
      component: JudgeView,
      meta: { title: 'セルモン商品審査', favicon: '/favicon-judge.svg' },
    },
    {
      path: '/product-edit',
      name: 'product-edit',
      component: ProductEditView,
      meta: { title: 'セルモン商品編集', favicon: '/favicon-edit.svg' },
    },
    {
      path: '/users',
      name: 'users',
      component: UserManagementView,
      meta: { title: 'ユーザ管理', favicon: DEFAULT_FAVICON },
      // Admin以外がURL直打ちで来た場合はトップへ戻す(実際の認可はAPI側のis_adminで行う。
      // ここはメニューを隠しているのと同じ、あくまでUXのためのガード)。
      beforeEnter: () => {
        const auth = useAuthStore()
        if (!auth.isAdmin) return '/'
        return true
      },
    },
  ],
})

router.afterEach((to) => {
  document.title = (to.meta.title as string) ?? 'セルモン審査'

  const href = (to.meta.favicon as string) ?? DEFAULT_FAVICON
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.type = 'image/svg+xml'
  link.href = href
})

export default router
